import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export async function getSpecialReport(config) {
    return httpUtils.get(`${env.API_VERSION}/quota-meter/special-reports`, config);
}

export async function getStartup(config) {
    return httpUtils.get(`${env.API_VERSION}/quota-meter/startups`, config);
}

export async function getInvestor(config) {
    return httpUtils.get(`${env.API_VERSION}/quota-meter/investors`, config);
}
